import { render, staticRenderFns } from "./CompareCommissionQuestions.vue?vue&type=template&id=98726aca"
import script from "./CompareCommissionQuestions.vue?vue&type=script&lang=js"
export * from "./CompareCommissionQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports